import { Sentry } from "@autocorp/sentry";
const escapeRegex = (p) => p.replace(/([/\\.$^[\]{}()-])/g, "\\$1");
export const onClientEntry = async (_, { pathPrefix, ...sentryOptions }) => {
    const iterateePathPattern = new RegExp(`^(${escapeRegex(location.origin)}/)${escapeRegex((pathPrefix || "")
        .replace(/^\/+|\/+$/g, ""))}/?`);
    Sentry.init(sentryOptions, {
        RewriteFrames: {
            iteratee: (frame) => {
                if (frame && frame.filename) {
                    frame.filename = frame.filename.replace(iterateePathPattern, "$1");
                }
                return frame;
            },
        },
    });
};
